
const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About</p>
        </div>
        <p className='text-xl mt-20'>
        I am a developer who is very passionate about this work, I like sports practicing MTB periodically, I spend my day learning and practicing the technologies learned
        </p>
        <br />
        <p className='text-xl'>
        I really like to interact and be curious about information related to technology, I am constantly learning to improve as a person and as a developer.
        </p>
      </div>
    </div>
  )
}

export default About